<template>
  <div>
    <PaginationWells class="pagination-row--top" v-if="type === 'wells'"> </PaginationWells>
    <slot></slot>
    <PaginationWells class="pagination-row--bottom" v-if="type === 'wells'"> </PaginationWells>
  </div>
</template>

<script>
import PaginationWells from "@/components/archive/pagination/Wells.vue";

export default {
  components: {
    PaginationWells
  },
  name: "ProductsPagination",
  data() {
    return {
      type: ws_vue_store.config.pagination
    };
  },
  created() {},
  methods: {}
};
</script>
